(function () {
    var BRANDS = ['audi','bmw','land-rover','lexus','mercedes','porsche','tesla','toyota','vw','volkswagen'];
    function getStageInfo() {
    var path = location.pathname;
    if (path.indexOf('fitment-finder') !== -1) return { stage: /^#make-/.test(location.hash) ? 2 : 1, brand: null };
    var p = path.match(/^\/pages\/([^\/]+)/);
    if (p && BRANDS.indexOf(p[1]) !== -1) {
    sessionStorage.setItem('fitmentBrand', p[1]);
    return { stage: 2, brand: p[1] };
    }
    var c = path.match(/^\/collections\/([^\/]+)/);
    if (c) {
    var slug = c[1];
    for (var i = 0; i < BRANDS.length; i++) {
    if (slug === BRANDS[i] || slug.indexOf(BRANDS[i] + '-') === 0) {
    sessionStorage.setItem('fitmentBrand', BRANDS[i]);
    return { stage: 3, brand: BRANDS[i] };
    }
    }
    var stored = sessionStorage.getItem('fitmentBrand');
    if (stored) return { stage: 3, brand: stored };
    }
    return null;
    }
    function inject() {
    var info = getStageInfo();
    if (!info) return;
    if (document.querySelector('.fitment-progress--injected')) return;
    if (!document.getElementById('cd-stepper-css')) {
    var st = document.createElement('style');
    st.id = 'cd-stepper-css';
    st.textContent = ".cd-stepper{position:relative;display:flex!important;flex-wrap:nowrap!important;gap:0!important;justify-content:space-between;align-items:flex-start;width:90%;max-width:520px;margin:0 auto;padding:30px 0}.cd-stepper__track{position:absolute;top:49px;left:11%;right:11%;height:2px;background:#e3e3e6;z-index:0}.cd-stepper__fill{position:absolute;top:49px;left:11%;height:2px;background:linear-gradient(90deg,#9a9aa2,#3a3a40);z-index:1;transition:width .5s cubic-bezier(.16,1,.3,1)}.cd-stepper__item{position:relative;z-index:2;display:flex;flex-direction:column;align-items:center;gap:9px;width:33%;text-decoration:none;cursor:default}a.cd-stepper__item{cursor:pointer}.cd-stepper__dot{width:38px;height:38px;border-radius:50%;border:2px solid #cdcdd2;background:#fff;display:flex;align-items:center;justify-content:center;font-family:'Instrument Sans',sans-serif;font-weight:700;font-size:.85rem;color:#a0a0a8;transition:all .35s cubic-bezier(.16,1,.3,1)}.cd-stepper__lbl{font-family:'Instrument Sans',sans-serif;font-size:.72rem;letter-spacing:.12em;text-transform:uppercase;color:#4c4c55;transition:color .3s}.cd-stepper__item.done .cd-stepper__dot{border-color:#1a1a1e;background:#1a1a1e;color:#fff}.cd-stepper__item.active .cd-stepper__dot{border-color:#1a1a1e;color:#1a1a1e;box-shadow:0 0 0 4px rgba(0,0,0,.08)}.cd-stepper__item.done .cd-stepper__lbl,.cd-stepper__item.active .cd-stepper__lbl{color:#1a1a1e}a.cd-stepper__item:hover .cd-stepper__dot{transform:translateY(-2px)}@media (prefers-reduced-motion:reduce){.cd-stepper__fill,.cd-stepper__dot{transition:none}}@media (max-width:749px){.cd-stepper{padding:12px 0;width:94%}.cd-stepper__dot{width:24px;height:24px;font-size:.66rem;border-width:1.5px}.cd-stepper__lbl{font-size:.56rem;letter-spacing:.09em}.cd-stepper__track,.cd-stepper__fill{top:24px}.cd-stepper__item{gap:5px}.cd-stepper__item.active .cd-stepper__dot{box-shadow:0 0 0 3px rgba(0,0,0,.08)}}";
    document.head.appendChild(st);
    }
    var stage = info.stage;
    function mkStep(n, label, href, isLink) {
    var cls = n < stage ? ' done' : (n === stage ? ' active' : '');
    var inner = '<span class="cd-stepper__dot">' + (n < stage ? '✓' : n) + '</span><span class="cd-stepper__lbl">' + label + '</span>';
    if (isLink && href) return '<a class="cd-stepper__item' + cls + '" href="' + href + '">' + inner + '</a>';
    return '<span class="cd-stepper__item' + cls + '">' + inner + '</span>';
    }
    var bar = document.createElement('div');
    bar.className = 'fitment-progress--injected cd-stepper';
    var fillPct = (stage - 1) / 2 * 78;
    bar.innerHTML = '<div class="cd-stepper__track"></div><div class="cd-stepper__fill" style="width:' + fillPct + '%"></div>' +
    mkStep(1, 'Make', '/pages/fitment-finder', stage > 1) +
    mkStep(2, 'Model', info.brand ? '/pages/' + info.brand : null, stage > 2 && !!info.brand) +
    mkStep(3, 'Parts', null, false);
    var main = document.querySelector('main#MainContent, main, [role="main"]') || document.body;
    var hero = main.querySelector('.cbg-hero, .cd-fit__hero, .cd-ph');
    if (hero) {
    hero.insertAdjacentElement('afterend', bar);
    } else {
    var firstSection = main.querySelector('.shopify-section, section');
    if (firstSection) firstSection.insertAdjacentElement('beforebegin', bar);
    else main.insertBefore(bar, main.firstChild);
    }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
    else inject();
    })();

(function(){
if(!('IntersectionObserver' in window))return;
var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}});},{threshold:0.15,rootMargin:'0px 0px -50px 0px'});
function init(){
var sels='.card,.product-card,.collection-card,.card-wrapper,a.cd-brand';
document.querySelectorAll(sels).forEach(function(el){el.classList.add('reveal-on-scroll');obs.observe(el);});
document.querySelectorAll('.button,.button--primary,.add-to-cart-button,a.button').forEach(function(btn){
btn.addEventListener('mousemove',function(e){var r=btn.getBoundingClientRect();var x=e.clientX-r.left-r.width/2;var y=e.clientY-r.top-r.height/2;btn.style.transform='translate('+(x*0.15)+'px, '+(y*0.15)+'px)';});
btn.addEventListener('mouseleave',function(){btn.style.transform='';});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
})();

/* Link-hijack transition removed 16 Jul 2026 — it added a flat 320ms to every internal
   navigation and left the page at pointer-events:none if the pageshow cleanup ever missed
   (the "blank page on Back" class). Links now navigate natively. */
(function(){
window.addEventListener('pageshow',function(){document.body.classList.remove('page-leaving');});
})();


// === Cursor spotlight tracker ===
(function(){
  var x = 0, y = 0, queued = false;
  document.addEventListener('mousemove', function(e){
    x = e.clientX; y = e.clientY;
    if (!queued) {
      queued = true;
      requestAnimationFrame(function(){
        document.body.style.setProperty('--cd-spot-x', x + 'px');
        document.body.style.setProperty('--cd-spot-y', y + 'px');
        queued = false;
      });
    }
  }, { passive: true });
})();


// === Trust strip on product pages ===
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  function inject(){
    return; /* disabled: replaced by .cd-pd__trust grid + fitting badge in cd-product.liquid */
    if (document.querySelector('.cd-trust')) return;
    var target = document.querySelector('product-form-component') || document.querySelector('.product-form') || document.querySelector('form[action*="/cart/add"]');
    if (!target) return;
    var strip = document.createElement('div');
    strip.className = 'cd-trust';
    strip.innerHTML = '<div class="cd-trust__item"><div class="cd-trust__icon"><svg viewBox="0 0 24 24"><path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z"/><path d="M9 12l2 2 4-4"/></svg></div><div class="cd-trust__text"><div class="cd-trust__title">Fitment Guaranteed</div><div class="cd-trust__sub">Doesn\'t fit? Free returns</div></div></div><a class="cd-trust__item cd-trust__item--link" href="/pages/installation"><div class="cd-trust__icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg></div><div class="cd-trust__text"><div class="cd-trust__title">Pro Installation</div><div class="cd-trust__sub">By 006 Customs, Dundalk</div></div></a><div class="cd-trust__item"><div class="cd-trust__icon"><svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg></div><div class="cd-trust__text"><div class="cd-trust__title">14-Day Returns</div><div class="cd-trust__sub">Hassle-free refunds</div></div></div>';
    target.parentNode.insertBefore(strip, target.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  setTimeout(inject, 500);
  setTimeout(inject, 1500);
})();


// === Trust strip override: damage protection ===
function cdUpdateTrustItem3() {
  var items = document.querySelectorAll('.cd-trust .cd-trust__item');
  if (items.length < 3) return;
  var item = items[2];
  var title = item.querySelector('.cd-trust__title');
  var sub = item.querySelector('.cd-trust__sub');
  var icon = item.querySelector('.cd-trust__icon');
  if (title) title.textContent = 'Damage Protection';
  if (sub) sub.textContent = 'Arrives damaged? Free replacement';
  if (icon) icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>';
}
setTimeout(cdUpdateTrustItem3, 600);
setTimeout(cdUpdateTrustItem3, 1700);
setTimeout(cdUpdateTrustItem3, 3000);


// === Trust strip item 2 wording fix ===
function cdUpdateTrustItem2() {
  var items = document.querySelectorAll('.cd-trust .cd-trust__item');
  if (items.length < 2) return;
  var item = items[1];
  var title = item.querySelector('.cd-trust__title');
  var sub = item.querySelector('.cd-trust__sub');
  if (title) title.textContent = 'Professional Installation';
  if (sub) sub.textContent = 'Trusted partner: 006 Customs';
}
setTimeout(cdUpdateTrustItem2, 600);
setTimeout(cdUpdateTrustItem2, 1700);
setTimeout(cdUpdateTrustItem2, 3000);



// === Product page: shrink title + move description below image ===
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  var style = document.createElement('style');
  style.textContent = '.product-information h1 { font-size: clamp(22px, 3vw, 32px) !important; line-height: 1.15 !important; letter-spacing: 0.5px !important; margin-bottom: 12px !important; } .product-information__media .cd-desc-moved { margin-top: 32px !important; padding-top: 24px !important; border-top: 1px solid #ebebeb !important; display: block !important; } .product-information__media:has(.cd-desc-moved) > media-gallery, .product-information__media:has(.cd-desc-moved) > .sticky-content { position: static !important; }';
  document.head.appendChild(style);
  function moveDesc() {
    if (document.querySelector('.cd-desc-moved')) return;
    var desc = document.querySelector('rte-formatter.rte');
    var mediaCol = document.querySelector('.product-information__media');
    if (!desc || !mediaCol) return;
    desc.classList.add('cd-desc-moved');
    mediaCol.appendChild(desc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveDesc);
  else moveDesc();
  setTimeout(moveDesc, 500);
  setTimeout(moveDesc, 1500);
})();


// === Move CORRECT description ===
function cdMoveDescV2() {
  if (document.querySelector('.cd-desc-moved-v2')) return;
  var mediaCol = document.querySelector('.product-information__media');
  if (!mediaCol) return;
  var grid = mediaCol.parentElement;
  if (!grid) return;
  var infoCol = Array.from(grid.children).find(function(c){ return c !== mediaCol; });
  if (!infoCol) return;
  var rtes = infoCol.querySelectorAll('rte-formatter');
  var desc = null;
  var maxLen = 0;
  rtes.forEach(function(el){
    var t = el.textContent.trim();
    if (t.length > maxLen) { maxLen = t.length; desc = el; }
  });
  if (!desc || maxLen < 50) return;
  desc.classList.add('cd-desc-moved-v2');
  desc.classList.add('cd-desc-moved');
  mediaCol.appendChild(desc);
}
setTimeout(cdMoveDescV2, 700);
setTimeout(cdMoveDescV2, 2000);
setTimeout(cdMoveDescV2, 3500);


// === Product page: cap gallery size + click-to-next === */
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  var style = document.createElement('style');
  style.textContent = '@media (min-width: 1000px) { .product-information__grid { grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) !important; max-width: 1200px !important; margin-left: auto !important; margin-right: auto !important; } .product-information__media { max-width: 560px !important; } .product-information__media media-gallery { max-height: 680px !important; } .product-information__media .product-media-container, .product-information__media .product-media { max-height: 680px !important; } .product-information__media img { max-height: 680px !important; object-fit: contain !important; } .product-information__media .product-media-container { cursor: pointer !important; } }';
  document.head.appendChild(style);
  function bindClickToNext() {
    var containers = document.querySelectorAll('.product-information__media .product-media-container');
    containers.forEach(function(c){
      if (c.dataset.cdClickBound) return;
      c.dataset.cdClickBound = '1';
      c.addEventListener('click', function(e){
        var nextBtn = document.querySelector('media-gallery .slideshow-control--next');
        if (nextBtn) {
          e.preventDefault();
          e.stopPropagation();
          nextBtn.click();
        }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindClickToNext);
  else bindClickToNext();
  setTimeout(bindClickToNext, 600);
  setTimeout(bindClickToNext, 1800);
})();


// === Stronger zoom-blocker for product gallery ===
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  function blockZoom() {
    var media = document.querySelector('.product-information__media');
    if (!media || media.dataset.cdZoomBlocked) return;
    media.dataset.cdZoomBlocked = '1';
    function handleClick(e) {
      var tgt = e.target.closest('.product-media-container, .product-media, img');
      if (!tgt) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var next = document.querySelector('media-gallery .slideshow-control--next');
      if (next) setTimeout(function(){ next.click(); }, 0);
      return false;
    }
    ['mousedown','click','pointerdown','touchstart'].forEach(function(ev){
      media.addEventListener(ev, handleClick, true);
    });
    var zoomTriggers = media.querySelectorAll('[class*="zoom"], [data-zoom], [aria-haspopup="dialog"]');
    zoomTriggers.forEach(function(el){ el.setAttribute('data-zoom-disabled', '1'); el.removeAttribute('aria-haspopup'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', blockZoom);
  else blockZoom();
  setTimeout(blockZoom, 600);
  setTimeout(blockZoom, 1800);
})();


// === Hover-to-zoom magnifier (no modal) ===
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  ['click','mousedown','pointerdown','touchstart'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var inMedia = e.target.closest('.product-information__media .product-media-container, .product-information__media .product-media');
      if (!inMedia) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }, true);
  });
  function setupZoom() {
    var images = document.querySelectorAll('.product-information__media .product-media-container img');
    images.forEach(function(img){
      var container = img.closest('.product-media-container');
      if (!container || container.dataset.cdHoverZoom) return;
      container.dataset.cdHoverZoom = '1';
      container.style.position = 'relative';
      container.style.overflow = 'hidden';
      container.style.cursor = 'zoom-in';
      var lens = document.createElement('div');
      lens.style.cssText = 'position:absolute;width:240px;height:240px;border-radius:50%;border:2px solid #fff;box-shadow:0 6px 24px rgba(0,0,0,0.4);pointer-events:none;display:none;z-index:10;background-repeat:no-repeat;background-color:#fff;';
      lens.style.backgroundImage = 'url("' + img.src + '")';
      container.appendChild(lens);
      var zoom = 2.5, size = 240;
      container.addEventListener('mouseenter', function(){ lens.style.display = 'block'; });
      container.addEventListener('mouseleave', function(){ lens.style.display = 'none'; });
      container.addEventListener('mousemove', function(e){
        var rect = container.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        if (x < 0 || y < 0 || x > rect.width || y > rect.height) { lens.style.display = 'none'; return; }
        lens.style.display = 'block';
        lens.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
        lens.style.backgroundPosition = -(x * zoom - size/2) + 'px ' + -(y * zoom - size/2) + 'px';
        lens.style.left = (x - size/2) + 'px';
        lens.style.top = (y - size/2) + 'px';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupZoom);
  else setupZoom();
  setTimeout(setupZoom, 700);
  setTimeout(setupZoom, 2000);
})();



// === Block zoom modal + thumbnail strip ===
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  function killZoomModal() {
    document.querySelectorAll('dialog').forEach(function(d){
      if (!d.className && d.querySelector('img') && !d.classList.contains('cart-drawer__dialog') && !d.classList.contains('search-modal__content')) {
        d.remove();
      }
    });
  }
  killZoomModal();
  setTimeout(killZoomModal, 300);
  setTimeout(killZoomModal, 1000);
  new MutationObserver(killZoomModal).observe(document.body, { childList: true });
  function buildThumbs() {
    var media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.cd-thumbs')) return;
    var slides = media.querySelectorAll('.product-media-container');
    if (slides.length < 2) return;
    var thumbs = document.createElement('div');
    thumbs.className = 'cd-thumbs';
    thumbs.style.cssText = 'display:grid;grid-template-columns:repeat(' + Math.min(slides.length, 5) + ',1fr);gap:8px;margin-top:16px;';
    slides.forEach(function(slide){
      var img = slide.querySelector('img');
      if (!img) return;
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'cd-thumb';
      t.style.cssText = 'aspect-ratio:1/1;border:1px solid #ddd;padding:0;background:#fff;cursor:pointer;overflow:hidden;';
      var ti = document.createElement('img');
      ti.src = img.src;
      ti.style.cssText = 'width:100%;height:100%;object-fit:cover;pointer-events:none;';
      t.appendChild(ti);
      t.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        slide.scrollIntoView({ behavior:'smooth', inline:'start', block:'nearest' });
      });
      thumbs.appendChild(t);
    });
    media.appendChild(thumbs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildThumbs);
  else buildThumbs();
  setTimeout(buildThumbs, 700);
  setTimeout(buildThumbs, 2000);
})();


// PASTE at end of fitment-progress.js
// Auto-injects a Fitment list at the bottom of any product page description that's missing one
(function(){
  if (!/^\/products\//.test(location.pathname)) return;
  function parseFitment(title) {
    var p = title.replace(/\s*(Carbon Fibre|Carbon Fibre|Carbon)\s+.*$/i, '').trim();
    if (!p) return [title];
    var m = p.match(/^([A-Z][\w\s]+?)\s+([\w\d-]+(?:\/[\w\d-]+)+)(.*)$/);
    if (m) {
      var brand = m[1].trim(), suffix = m[3].trim();
      return m[2].split('/').map(function(v){ return (brand + ' ' + v + (suffix ? ' ' + suffix : '')).trim(); });
    }
    return [p];
  }
  function inject() {
    return; // Fitment auto-injection disabled — Make/Model/Years now shown as metafields    var h1 = document.querySelector('.product-information h1');
    if (!h1) return;
    var rtes = document.querySelectorAll('rte-formatter');
    var desc = null, max = 0;
    rtes.forEach(function(el){ var t = el.textContent.trim(); if (t.length > max) { max = t.length; desc = el; } });
    if (!desc || max < 50) return;
    if (/<strong>Fitment<\/strong>/i.test(desc.innerHTML)) return;
    var items = parseFitment(h1.textContent.trim());
    var html = '<p class="cd-injected-fitment" style="margin-top:16px;"><strong>Fitment</strong></p><ul class="cd-injected-fitment">';
    items.forEach(function(f){ html += '<li>' + f + '</li>'; });
    html += '</ul>';
    desc.insertAdjacentHTML('beforeend', html);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  setTimeout(inject, 600);
  setTimeout(inject, 2000);
})();

// Remove pre-existing Fitment sections from product descriptions
(function(){
  function removeFitment(){
      document.querySelectorAll('strong').forEach(function(s){
            if (s.textContent.trim().toLowerCase() === 'fitment') {
                    var p = s.closest('p');
                            if (!p) return;
                                    var next = p.nextElementSibling;
                                            if (next && (next.tagName === 'UL' || next.tagName === 'OL')) next.remove();
                                                    p.remove();
                                                          }
                                                              });
                                                                }
                                                                  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeFitment);
                                                                    else removeFitment();
                                                                      setTimeout(removeFitment, 600);
                                                                        setTimeout(removeFitment, 2000);
                                                                        })();
